import Blob from './src/Blob.js';
import Export2Excel, {
  export_json_to_excel
} from './src/Export2Excel.js'


export default function MExcel({
  excelPath,
  excelParams = {},
  excelData = [],
  excelLoading = false,
  excelTitle = "列表",
  excelColumns = [],
  excelLabels = [],
  excelProps = [],
} = {}) {
  return {
    data() {
      return {
        excelPath,
        excelParams,
        excelData,
        excelLoading,
        excelTitle,
        excelColumns,
        excelLabels,
        excelProps,
      }
    },
    methods: {
      excelGetBeforeFn: function() {},
      excelGetAfterFn: function() {},
      excelBeforeFn() {},
      excelGet(tag) {
        /* if (!this.excelPath) {
          (process.env.NODE_ENV == 'development') && (
            console.warn("Please set excelPath")
          );
          return;
        }
        let params = this.excelGetBeforeFn(this.excelParams) || this.excelParams;
        this.excelLoading = true;
        this.$http.post(this.excelPath, params).then(res => {
          if (res.code === 200) {
            this.excelData = this.excelGetAfterFn(res.data) || res.data;
            if (tag) {
              this.excelExport();
            }
          }
          this.excelLoading = false;
        }).catch(err => {
          this.excelLoading = false;
          console.error(err);
        }) */
        if (tag) {
          this.excelData = this.excelGetAfterFn(this.excelData) || this.excelData;
          this.excelLoading = true;
          this.excelExport();
          this.excelLoading = false;
        }
      },
      excelExport() {
        let {
          excelLabels,
          excelProps,
        } = this.excelColumns.reduce((pre, cur) => {
          if (this.excelProps.includes(cur.prop)) {
            pre.excelLabels.push(cur.label);
            pre.excelProps.push(cur.prop);
          }
          return pre;
        }, {
          excelLabels: [],
          excelProps: [],
        })
        this.excelLabels = excelLabels;
        this.excelProps = excelProps;
        const excelData = this.excelBeforeFn(this.excelData) || this.excelData;
        const data = formatJson(this.excelProps, excelData);
        require.ensure([], () => {
          export_json_to_excel(this.excelLabels, data, this.excelTitle);
        })
      }
    },
    mounted() {
      if (this.excelColumns && this.excelColumns instanceof Array) {
        this.excelColumns.forEach(item => {
          this.excelLabels.push(item.label);
          this.excelProps.push(item.prop);
        })
      } else {
        console.warn("Please set excelColumns")
      }
    }
  }
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]))
}
